/**
 * Represents the available locales.
 */
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum Locale {
  EN_GLOBAL = 'en-us', // English/USA
  DE_GLOBAL = 'de-us', // German/USA
  ES_GLOBAL = 'es-us', // Spanish/USA
  IT_GLOBAL = 'it-us', // Italian/USA
  JA_GLOBAL = 'ja-us', // Japanese/USA
  ZH_GLOBAL = 'zh-us', // Chinese/USA
  EN_US = 'en-us', // English/USA
  EN_UK = 'en-gb', // English/UK - n.b. GB is ISO 3166, but UK used for nav
  EN_CA = 'en-ca', // English/Canada
  EN_AC_REGION = 'en-ac', // English/Asia Regional Site
  EN_AC = 'en-ac', // English/Asia Regional Site (Asia Continent)
  EN_AU = 'en-au', // English/Australia
  EN_NZ = 'en-nz', // English/New Zealand
  EN_KR = 'en-kr', // English/South Korea
  ZH_HK = 'zh-hk', // Chinese/Hong Kong
  EN_HK = 'en-hk', // English/Hong Kong
  DE_AT = 'de-at', // German/Austria
  EN_AT = 'en-at', // English/Austria
  DE_DE = 'de-de', // German/Germany
  EN_DE = 'en-de', // English/Germany
  EN_LT = 'en-lt', // English/Lithuania
  EN_SE = 'en-se', // English/Sweden
  SV_SE = 'sv-se', // Sweden/Sweden
  EN_BE = 'en-be', // English/Belgium
  FR_BE = 'fr-be', // French/Belgium
  NL_BE = 'nl-be', // Dutch/Belgium
  EN_IS = 'en-is', // English/Iceland
  IS_IS = 'is-is', // Icelandic/Iceland
  EN_LU = 'en-lu', // English/Luxembourg
  DE_CH_CH = 'de-ch-ch', // German/Switzerland
  DE_CH = 'de-ch', // German/Switzerland
  FR_CH = 'de-ch', // French/Switzerland
  IT_CH = 'it-ch', // Italian/Switzerland
  EN_CH = 'en-ch', // English/Switzerland
  EN_DK = 'en-dk', // English/Denmark
  DA_DK = 'da-dk', // Denmark/Denmark
  EN_IE = 'en-ie', // English/Ireland
  EN_NL = 'en-nl', // English/Netherlands
  NL_NL = 'nl-nl', // Dutch/Netherlands
  EN_EE = 'en-ee', // English/Estonia
  IT_IT = 'it-it', // Italian/Italy
  EN_IT = 'en-it', // English/Italy
  EN_NO = 'en-no', // English/Norway
  NO_NO = 'no-no', // Norway/Norway
  EN_FI = 'en-fi', // English/Finland
  SV_FI = 'sv-fi', // English/Finland
  FI_FI = 'fi-fi', // Finish/Finland
  EN_LV = 'en-lv', // English/Latvia
  EN_PT = 'en-pt', // English/Portugal
  PT_PT = 'pt-pt', // Portugal/Portugal
  EN_FR = 'en-fr', // English/France
  EN_LI = 'en-li', // English/liechtenstein
  ES_ES = 'es-es', // Spanish/Spain
  EN_ES = 'en-es', // English/Spain
  EN_JP = 'en-jp', // English/Japan
  JA_JP = 'ja-jp', // Japanese/Japan
  EN_SG = 'en-sg', // English/Singapore
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */
